document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('video');
    const soundToggle = document.getElementById('soundToggle');

    // Set video source based on the device type
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    video.src = isMobile
        ? 'https://cdn.shopify.com/videos/c/o/v/1e375d4ca3124ba49f1ca504c0353a37.mp4'
        : 'https://cdn.shopify.com/videos/c/o/v/a09f875723ea48d191b3a6c378e34af2.mp4';

    // Toggle sound on button click
    soundToggle.addEventListener('click', () => {
        if (video.muted) {
            video.muted = false;
            soundToggle.textContent = 'Sound Off';
        } else {
            video.muted = true;
            soundToggle.textContent = 'Sound On';
        }
    });
});


